import { EventEmitter } from '@angular/core'

type UnknownObject = Record<string, unknown>

export type AdvancedOptionsParams<T = unknown, K = UnknownObject> = {
  context: T
} & K

export abstract class AdvancedOptionsBase<T = unknown, K = UnknownObject> {
  abstract onChange: EventEmitter<AdvancedOptionsParams<T, K>>
  abstract advancedOptionsParams?: AdvancedOptionsParams<T, K>
  abstract onApply(): void
}
